import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import { fetchFaqs } from "../../store/slices/faqsSlice";
import FaqsAccordion from "../../components/FaqsAccordion";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import AllFaqSkeleton from "../../components/skeletons/AllFaqSkeleton";
import Pagination from "../../components/Pagination";

function AllFaq() {
  const dispatch = useDispatch();
  const {
    data: { faqs, title, description },
    status,
    error,
    currentPage,
    itemsPerPage,
    totalPages,
  } = useSelector((state) => state.faqs);

  // Fetch FAQs when currentPage or itemsPerPage changes
  useEffect(() => {
    dispatch(fetchFaqs({ page: currentPage, itemsPerPage: itemsPerPage }));
  }, [dispatch, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      dispatch(fetchFaqs({ page, itemsPerPage }));
    }
  };

  const handlePerPageChange = (perPage) => {
    dispatch(fetchFaqs({ page: 1, itemsPerPage: perPage }));
  };

  if (status === "loading") {
    return <AllFaqSkeleton />;
  }

  if (status === "succeeded" && faqs?.length > 0) {
    return (
      <>
        <TopHeader btn={true} />
        <div className="container space-bloc">
          <div className="row">
            <div>
              <h2 className="grey500 mb-8">{title}</h2>
              <p className="body grey66 mt-16">{description}</p>
            </div>
            <div>
              <FaqsAccordion elements={faqs} />
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            lastPage={totalPages}
            perPage={itemsPerPage}
            onPageChange={handlePageChange}
            onPerPageChange={handlePerPageChange}
          />
        </div>
        <Footer />
      </>
    );
  }

  return (
    <div className="container space-bloc">
      <p>
        {status === "failed"
          ? `Erreur de chargement des FAQs: ${
              error?.message || "Erreur inconnue"
            }`
          : "Aucune FAQ disponible."}
      </p>
    </div>
  );
}

export default AllFaq;
